import { Stack, StackProps } from "@mui/material";
import { APP_ICONS, SmEmailIcon, SmPhoneIcon } from "Assets/icons";
import { CompanyIcon } from "Assets/icons/company.icon";
import { APP_IMGS } from "Assets/images";
import { SmText, SmTextMd, TextMd, XsText } from "Components";
import { ALink } from "Components/link";
import { COLORS } from "constants/layout";
import { useTranslation } from "hooks/useTranslation";
import React from "react";

const FreshdiSupport = (props: StackProps) => {
  const t = useTranslation();

  const infors = [
    {
      icon: SmPhoneIcon,
      value: "84397260875",
      label: "phone",
      whatsapp: "https://api.whatsapp.com/send?phone=84397260875",
      verified: true,
    },
    {
      icon: SmEmailIcon,
      value: "agent1.cs@freshdi.vn",
      label: "email",
      verified: true,
    },
    {
      icon: CompanyIcon,
      value: "Chloe - Freshdi Business Consulting",
      label: "company",
    },
  ];

  return (
    <Stack spacing={1} {...props}>
      <TextMd>{t("freshdi_support")}</TextMd>
      <Stack p={1.5} direction="row" spacing={1.5}>
        <img src={APP_ICONS.squareLogo} alt="icon" width={40} height={40} loading="lazy"/>
        <SmText color={COLORS.gray[700]}>{t("freshdi_support_desc")}</SmText>
      </Stack>

      <Stack direction="row" spacing={1}>
        <img
          src={APP_IMGS.common.desktop["chloeAvatar"]}
          alt="icon"
          width={40}
          height={40}
          loading="lazy"
        />
        <Stack spacing={0.5}>
          <SmTextMd color={COLORS.gray[800]}>Ms. Chloe Tran</SmTextMd>
          <XsText color={COLORS.gray[600]}>{t("biz_consulting")}</XsText>
        </Stack>
      </Stack>

      <Stack>
        {infors.map(({ value, icon: Icon, label, whatsapp, verified }, i) => {
          return (
            <Stack key={i} spacing={1} direction="row" alignItems="center">
              <Stack p={1} position="relative">
                <Icon className="label" width={16} />
                {verified && (
                  <img
                    src={APP_ICONS.circleCheck}
                    alt="icon"
                    width={10}
                    height={10}
                    style={{
                      position: "absolute",
                      top: 0,
                      right: 0,
                    }}
                    loading="lazy"
                  />
                )}
              </Stack>
              <Stack direction="row" spacing={1} flex={1} alignItems="center">
                <SmText className="value" color={COLORS.gray[500]} p={1}>
                  {t(label)}:{" "}
                  <span style={{ color: COLORS.green[600] }}>{value}</span>
                </SmText>
                {whatsapp && (
                  <ALink href={whatsapp} openNewTab>
                    <img
                      src={APP_ICONS.whatsapp}
                      alt="whatsapp"
                      width={32}
                      height={32}
                      loading="lazy"
                    />
                  </ALink>
                )}
              </Stack>
            </Stack>
          );
        })}
      </Stack>
    </Stack>
  );
};

export default FreshdiSupport;
